export function initAuth(netlifyIdentity) {
  netlifyIdentity.init({
    logo: false,
  });
}

export default {
  initAuth,
};
